<template>
    <v-row>
      <v-col cols="12">
          <product-stock-report> </product-stock-report> 
      </v-col>
    </v-row>
  </template>
  <script>
  import ProductStockReport from "@/components/report/ProductStockReportCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Product Stock Report",
    },
  
    components: {
        ProductStockReport
    },
  
    data() {
      return {
      };
    },
  };
  </script>